import type { SitrepSectionType } from 'components/DisasterGPT/hooks/useSitrepsV2';

/**
 * Written sections only. Analytics, lists, and generated sections stay on the
 * full report.
 */
export function textareaSections(
  sections: SitrepSectionType[] | undefined
): SitrepSectionType[] {
  const parentIds = new Set(
    (sections ?? [])
      .map((section) => section.parent_section_id)
      .filter((id): id is string => Boolean(id))
  );
  return (sections ?? [])
    .filter(
      (section) =>
        section.type === 'manual' &&
        !section.previewSectionId &&
        !parentIds.has(section.id)
    )
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function fullSitrepHref(sitrepId: string, aorId: string): string {
  const params = new URLSearchParams({
    openTab: 'Reports',
    sitrepTab: 'CurrentSITREP',
    openReport: sitrepId,
    aorId,
  });
  return `/hub?${params.toString()}`;
}
